var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _IconByTypes;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CheckCircleIcon, CancelIcon, WarningIcon, HelpIcon, InfoIcon } from '@cxagroup/casper-icons';
import Modal from '../modal';

var TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  QUESTION: 'question',
  INFO: 'info'
};

var IconByTypes = (_IconByTypes = {}, _IconByTypes[TYPES.SUCCESS] = CheckCircleIcon, _IconByTypes[TYPES.ERROR] = CancelIcon, _IconByTypes[TYPES.WARNING] = WarningIcon, _IconByTypes[TYPES.QUESTION] = HelpIcon, _IconByTypes[TYPES.INFO] = InfoIcon, _IconByTypes);

var getIconForType = function getIconForType(type) {
  return IconByTypes[type];
};
var getDefaultType = function getDefaultType() {
  return TYPES.SUCCESS;
};

var AlertModal = function AlertModal(_ref) {
  var _ref$defaultIcon = _ref.defaultIcon,
      defaultIcon = _ref$defaultIcon === undefined ? false : _ref$defaultIcon,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? defaultIcon && getDefaultType() : _ref$type,
      title = _ref.title,
      body = _ref.body,
      footer = _ref.footer,
      _ref$Icon = _ref.Icon,
      Icon = _ref$Icon === undefined ? getIconForType(type) : _ref$Icon,
      modalProps = _objectWithoutProperties(_ref, ['defaultIcon', 'type', 'title', 'body', 'footer', 'Icon']);

  return React.createElement(
    Modal,
    _extends({}, modalProps, { className: 'modal--alert' }),
    React.createElement(
      'header',
      { className: 'modal__header' },
      Icon && React.createElement(Icon, { className: 'modal__icon icon icon--' + type }),
      React.createElement(
        'h3',
        { className: 'modal__title' },
        title
      )
    ),
    React.createElement(
      'div',
      { className: 'modal__body' },
      body
    ),
    footer && React.createElement(
      'footer',
      { className: 'modal__footer' },
      footer
    )
  );
};

AlertModal.types = TYPES;

AlertModal.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  footer: PropTypes.node,
  defaultIcon: PropTypes.bool
} : {};

export default AlertModal;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/alert-modal/alert-modal.js
// module id = null
// module chunks = 